document.documentElement.classList.remove('no-js');

function setupDrawer() {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-drawer-toggle]');
  const drawer = document.getElementById('SiteHeaderDrawer');
  if (!toggle || !drawer) return;

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    drawer.hidden = expanded;
    document.body.classList.toggle('has-drawer-open', !expanded);
  });
}

function setupHeaderSearch() {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-search-toggle]');
  const form = header.querySelector('[data-header-search]');
  const input = header.querySelector('[data-header-search-input]');
  const results = header.querySelector('[data-header-search-results]');
  const cancel = header.querySelector('[data-search-cancel]');
  if (!toggle || !form || !input || !results) return;

  let timer = 0;

  const openSearch = () => {
    toggle.setAttribute('aria-expanded', 'true');
    form.hidden = false;
    header.classList.add('has-search-open');
    input.focus();
  };

  const closeSearch = () => {
    toggle.setAttribute('aria-expanded', 'false');
    form.hidden = true;
    results.hidden = true;
    input.value = '';
    results.innerHTML = '';
    header.classList.remove('has-search-open');
  };

  const renderResults = (products) => {
    if (!products.length) {
      results.innerHTML = '<p class="site-header__search-empty">No products found</p>';
      results.hidden = false;
      return;
    }

    results.innerHTML = products.map((product) => {
      const image = product.image
        ? `<img src="${product.image}" alt="${product.title}">`
        : '';
      const priceValue = Number(product.price || 0);
      const price = priceValue ? `<span>${formatMoney(priceValue * 100, 'INR')}</span>` : '';
      return `
        <a class="site-header__search-result" href="${product.url}">
          ${image}
          <span>${product.title}</span>
          ${price}
        </a>
      `;
    }).join('');
    results.hidden = false;
  };

  const fetchResults = async () => {
    const q = input.value.trim();
    if (q.length < 2) {
      results.hidden = true;
      results.innerHTML = '';
      return;
    }

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search failed');
      const data = await response.json();
      renderResults(data.resources?.results?.products || []);
    } catch (error) {
      results.hidden = true;
    }
  };

  toggle.addEventListener('click', () => {
    if (form.hidden) openSearch();
    else closeSearch();
  });

  cancel?.addEventListener('click', closeSearch);

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(fetchResults, 180);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSearch();
  });
}

function setupProductGalleries() {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length <= 1) return;

    let index = 0;
    const setIndex = (nextIndex) => {
      const total = slides.length;
      index = (nextIndex + total) % total;
      track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;
      gallery.dataset.index = String(index);
    };

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIndex(index - 1);
    });

    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIndex(index + 1);
    });

    gallery.closest('[data-product-card]')?.addEventListener('mouseleave', () => {
      setIndex(0);
    });
  });
}

function setupMarquee() {
  document.querySelectorAll('[data-marquee-track]').forEach((track) => {
    if (!track) return;
    let pos = 0;
    const speed = 0.35;

    const tick = () => {
      pos -= speed;
      const width = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 0;
      if (width && Math.abs(pos) >= width) pos = 0;
      track.style.transform = `translate3d(${pos}px, 0, 0)`;
      window.requestAnimationFrame(tick);
    };

    window.requestAnimationFrame(tick);
  });
}

function formatMoney(cents, currency) {
  const amount = Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency || 'INR',
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);
  } catch (error) {
    return `${currency || 'INR'} ${amount.toFixed(2)}`;
  }
}

function cartItemMarkup(item, currency) {
  const image = item.image
    ? `<a class="bd-cart-drawer__item-media" href="${item.url}"><img src="${item.image}&width=240" alt="${item.product_title}" loading="lazy"></a>`
    : `<a class="bd-cart-drawer__item-media" href="${item.url}"></a>`;
  const variant = item.variant_title && item.variant_title !== 'Default Title'
    ? `<p>${item.variant_title}</p>`
    : '';

  return `
    <article class="bd-cart-drawer__item">
      ${image}
      <div>
        <a class="bd-cart-drawer__item-title" href="${item.url}">${item.product_title}</a>
        ${variant}
        <span>${item.quantity} x ${formatMoney(item.final_price, currency)}</span>
      </div>
    </article>
  `;
}

function setupCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('[data-cart-drawer-items]');
  const totalEl = drawer.querySelector('[data-cart-drawer-total]');
  const currency = drawer.dataset.currency || 'INR';

  const openDrawer = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-cart-drawer-open');
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-cart-drawer-open');
  };

  const renderCart = (cart) => {
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.length
        ? cart.items.map((item) => cartItemMarkup(item, cart.currency || currency)).join('')
        : '<p class="bd-cart-drawer__empty">Your bag is empty.</p>';
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency || currency);

    document.querySelectorAll(`a[href="/cart"], a[href="${window.Shopify?.routes?.root || '/'}cart"]`).forEach((link) => {
      if (/bag/i.test(link.textContent)) {
        link.textContent = cart.item_count > 0 ? `bag (${cart.item_count})` : 'bag';
      }
    });
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to fetch cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submit = form.querySelector('[type="submit"]');
      event.preventDefault();

      try {
        submit?.setAttribute('disabled', 'disabled');
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
          form.submit();
          return;
        }

        await refreshCart();
        openDrawer();
      } catch (error) {
        form.submit();
      } finally {
        submit?.removeAttribute('disabled');
      }
    });
  });
}

function setupProductDetail() {
  document.querySelectorAll('[data-product-detail]').forEach((root) => {
    const json = root.querySelector('[data-product-json]');
    const hiddenVariantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const comparePriceEl = root.querySelector('[data-compare-price]');
    const statusEl = root.querySelector('[data-variant-status]');
    const addToCartButton = root.querySelector('[data-add-to-cart]');
    const addLabelEl = root.querySelector('[data-add-label]');
    const spotlightTitleEl = root.querySelector('[data-spotlight-title]');
    const spotlightImageEl = root.querySelector('[data-spotlight-image]');
    const thumbButtons = Array.from(root.querySelectorAll('[data-media-thumb]'));
    const mediaPanels = Array.from(root.querySelectorAll('[data-media-panel]'));
    const quantityInput = root.querySelector('[data-quantity-input]');
    const optionCount = Number(root.dataset.optionCount || 0);
    const currency = root.dataset.currency || 'INR';
    const addLabel = root.dataset.addLabel || 'Add to bag';
    const inStockLabel = root.dataset.inStockLabel || 'In stock';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';

    if (!json || !hiddenVariantInput) return;

    const product = JSON.parse(json.textContent);
    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));

    const setActiveMedia = (mediaId, options = {}) => {
      if (!mediaId) return;
      const shouldScroll = options.scroll === true;

      mediaPanels.forEach((panel) => {
        const isActive = String(panel.dataset.mediaId) === String(mediaId);
        panel.classList.toggle('is-active', isActive);

        if (isActive && shouldScroll) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      thumbButtons.forEach((button) => {
        const isActive = String(button.dataset.mediaId) === String(mediaId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    const selectedOptions = () => {
      const values = [];

      for (let i = 1; i <= optionCount; i += 1) {
        const checked = root.querySelector(`[name="option-${i}"]:checked`);
        values.push(checked ? checked.value : '');
      }

      return values;
    };

    const findVariant = () => {
      if (!optionCount) {
        return product.variants.find((variant) => String(variant.id) === String(hiddenVariantInput.value)) || product.variants[0];
      }

      const values = selectedOptions();
      return product.variants.find((variant) => variant.options.every((optionValue, index) => optionValue === values[index])) || null;
    };

    const updateVariant = (variant, options = {}) => {
      if (!variant) {
        addToCartButton?.setAttribute('disabled', 'disabled');
        if (addLabelEl) addLabelEl.textContent = 'Unavailable';
        if (statusEl) statusEl.textContent = 'Unavailable';
        return;
      }

      hiddenVariantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price, currency);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price, currency);
          comparePriceEl.classList.remove('is-hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('is-hidden');
        }
      }

      if (statusEl) {
        statusEl.textContent = variant.available ? inStockLabel : soldOutLabel;
      }

      if (addToCartButton) {
        addToCartButton.disabled = !variant.available;
      }

      if (addLabelEl) {
        addLabelEl.textContent = variant.available ? addLabel : soldOutLabel;
      }

      if (spotlightTitleEl) {
        spotlightTitleEl.textContent = variant.title && variant.title !== 'Default Title'
          ? variant.title
          : product.title;
      }

      const variantImageSrc = variant.featured_image?.src || variant.featured_media?.preview_image?.src;

      if (spotlightImageEl && variantImageSrc) {
        spotlightImageEl.src = variantImageSrc;
        spotlightImageEl.srcset = '';
        spotlightImageEl.alt = product.title;
      }

      if (variant.featured_media?.id) {
        setActiveMedia(variant.featured_media.id, { scroll: options.scroll === true });
      }

      if (window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveMedia(button.dataset.mediaId, { scroll: true });
      });
    });

    if (mediaPanels.length > 1 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((left, right) => right.intersectionRatio - left.intersectionRatio)[0];

        if (visibleEntry?.target?.dataset?.mediaId) {
          setActiveMedia(visibleEntry.target.dataset.mediaId);
        }
      }, {
        threshold: [0.35, 0.6, 0.85],
        rootMargin: '-10% 0px -20% 0px',
      });

      mediaPanels.forEach((panel) => observer.observe(panel));
    }

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateVariant(findVariant(), { scroll: true });
      });
    });

    root.querySelector('[data-quantity-increase]')?.addEventListener('click', () => {
      const currentValue = Number(quantityInput?.value || 1);
      if (quantityInput) quantityInput.value = String(currentValue + 1);
    });

    root.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => {
      const currentValue = Number(quantityInput?.value || 1);
      if (quantityInput) quantityInput.value = String(Math.max(1, currentValue - 1));
    });

    quantityInput?.addEventListener('change', () => {
      const nextValue = Number(quantityInput.value || 1);
      quantityInput.value = String(Math.max(1, nextValue || 1));
    });

    updateVariant(findVariant());
  });
}

function setupCartQuantityControls() {
  document.querySelectorAll('.bd-cart').forEach((root) => {
    root.querySelectorAll('[data-cart-quantity-increase]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement?.querySelector('[data-cart-quantity-input]');
        if (!input) return;
        input.value = String(Number(input.value || 0) + 1);
      });
    });

    root.querySelectorAll('[data-cart-quantity-decrease]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement?.querySelector('[data-cart-quantity-input]');
        if (!input) return;
        input.value = String(Math.max(0, Number(input.value || 0) - 1));
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupDrawer();
  setupHeaderSearch();
  setupProductGalleries();
  setupMarquee();
  setupProductDetail();
  setupCartQuantityControls();
  setupCartDrawer();
});
